const isDev = process.env.NODE_ENV === 'development';
const serverUrl = isDev ? 'https://localhost:7148' : 'http://api.mylittlesecret.fashion:5001';

export const Config =  {
    isDevenv: isDev,
    // if is development environment, then use local server for webSocketUrl
    priceHubUrl: serverUrl+'/priceHub',
}
